import { classNames } from "@lib/HtmlUtil"
import React from "react"
import { Table, TableProps } from "./Table"

export function FormTable({ className, ...props }: TableProps) {
    return <Table className={classNames("table--form", className)} {...props} />
}
